import Helper from './Helper/index';
import Layout from './Layout/index';
import Template from './Template/index';
import Ui from './Ui/index';
import BlockLoader from './BlockLoader';
import Connect from './Connect';
import DataApplier from './DataApplier';
import MessageFader from './MessageFader';
import Popup from './Popup';
import Polling from './Polling';
import SearchListControl from './SearchListControl';
import { on, off, trigger } from './trigger';
import { pages, page } from './page';

export default {
    Helper,
    Layout,
    Template,
    Ui,
    BlockLoader,
    Connect,
    DataApplier,
    MessageFader,
    Polling,
    Popup,
    SearchListControl,
    on,
    off,
    trigger,
    page,
    pages
}
